import { Button } from "@mui/material";
import { Link } from "react-router-dom";
import { newTextSchema } from "../utils/yup/yup-schemas";
import { GridColDef } from "@mui/x-data-grid";
import { ItemWithFields } from "../types/fnProps";

const textColumns: GridColDef[] = [
    { field: 'id', headerName: 'ID', flex: 2 },
    { field: 'value', headerName: 'Value', flex: 4 },
    {
        field: 'select',
        headerName: 'Select',
        sortable: false,
        flex: 2,
        renderCell: (params) => (
            <Link to={`/texts/${params.id}`}>
                <Button variant="contained">
                    View
                </Button>
            </Link>
        )
    }
];

const fields = {
    key: '',
    value: ''
};

const textFA = [
    { label: 'Title', id: 'key' },
    { label: 'Value', id: 'value', multiline: true }
];

const textProps: ItemWithFields = {
    itemType: 'texts',
    name: 'id',
    columns: textColumns,
    sorting: { field: 'id', sort: 'asc' },
    pageSize: 25,
    pageSizeOptions: [10, 25, 50],
    fields: fields,
    fieldsArray: textFA,
    steps: ['fieldsArray', 'preview'],
    fieldsArraySchema: newTextSchema
};

export default textProps;